
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { FileText, Plus } from "lucide-react";

interface EmptyDocumentationProps {
  onStartEditing: () => void;
}

export function EmptyDocumentation({ onStartEditing }: EmptyDocumentationProps) {
  return (
    <Card className="border border-dashed border-[#05445e]/30">
      <CardContent className="pt-6">
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <div className="mb-4 rounded-full bg-[#75e6da]/20 p-3">
            <FileText className="h-6 w-6 text-[#189ab4]" />
          </div>
          <h3 className="mb-2 text-xl font-medium">Sem documentação</h3>
          <p className="mb-6 text-sm text-muted-foreground max-w-md">
            Este componente ainda não possui documentação. Crie uma documentação detalhada para ajudar
            outros membros da equipe a entender seu propósito e funcionamento.
          </p>
          <Button 
            onClick={onStartEditing} 
            className="bg-[#189ab4] hover:bg-[#05445e]"
          >
            <Plus className="mr-2 h-4 w-4" /> 
            Criar Documentação
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
